export var BroadcastNodeCommand;
(function (BroadcastNodeCommand) {
    BroadcastNodeCommand["setValue"] = "broadcast_node.set_value";
    BroadcastNodeCommand["getEndpointCount"] = "broadcast_node.get_endpoint_count";
    BroadcastNodeCommand["supportsCC"] = "broadcast_node.supports_cc";
    BroadcastNodeCommand["getCCVersion"] = "broadcast_node.get_cc_version";
    BroadcastNodeCommand["invokeCCAPI"] = "broadcast_node.invoke_cc_api";
    BroadcastNodeCommand["supportsCCAPI"] = "broadcast_node.supports_cc_api";
    BroadcastNodeCommand["getDefinedValueIDs"] = "multicast_group.get_defined_value_ids";
})(BroadcastNodeCommand || (BroadcastNodeCommand = {}));
